import { CreditCardProductCategory } from '@appTypes/EligibilityApi.interface'

const aboutTitles: Record<CreditCardProductCategory, string> = {
    ['BalanceTransfer']: 'About balance transfer credit cards',
    ['BestCards']: 'About credit cards',
    ['Cashback']: 'About cashback credit cards',
    ['Combined']: 'About balance transfer and purchase credit cards',
    ['PoorCredit']: 'About credit cards for bad credit',
    ['Purchase']: 'About 0% purchase credit cards',
    ['Rewards']: 'About rewards credit cards',
    ['Travel']: 'About travel credit cards',
}

export default aboutTitles
